<template>
	<div v-loading="loading" class="exhibition-goods-detail" element-loading-text="正在加载商品详情...">
		<goods-detail-view v-if="goodsLoaded" :goods-type="2" :goods="goodsInfo" @consult="handleConsult" />
		<div v-else-if="!loading" class="goods-empty">
			<el-empty description="商品不存在或已下架">
				<el-button type="primary" @click="$router.push('/mallStore/index')">返回服务商城</el-button>
			</el-empty>
		</div>
	</div>
</template>

<script>
	import GoodsDetailView from './components/GoodsDetailView'
	import { previewMerchantFile, queryPublishedMerchantGoodsDetail } from '@/api/mall'

	const DEFAULT_GOODS_IMAGE = require('@/assets/mall/goods/goods-demo.png')

	export default {
		name: 'MallStoreExhibitionGoodsDetail',
		components: { GoodsDetailView },
		data() {
			return {
				loading: false,
				goodsLoaded: false,
				goodsInfo: {
					goodsId: '',
					title: '',
					introduction: '',
					category: '',
					shopName: '',
					mainImage: DEFAULT_GOODS_IMAGE,
					contactName: '',
					contactPhone: '',
					deliveryText: '',
					deliveryAgreement: '',
					detailContent: ''
				}
			}
		},
		created() {
			this.loadGoodsDetail()
		},
		methods: {
			async loadGoodsDetail() {
				const goodsId = this.$route.params.id
				this.loading = true
				this.goodsLoaded = false
				try {
					const response = await queryPublishedMerchantGoodsDetail({ id: goodsId })
					const goods = response.data
					if (!goods || Number(goods.goodsType) !== 2) return
					this.goodsInfo = this.mapGoodsDetail(goods)
					this.goodsLoaded = true
				} finally {
					this.loading = false
				}
			},
			mapGoodsDetail(goods) {
				const categories = [goods.categoryFirstName, goods.categorySecondName, goods.categoryThirdName].filter(Boolean)
				return {
					goodsId: goods.id,
					title: goods.goodsTitle || goods.guideTitle || '未命名商品',
					introduction: goods.guideTitle || '',
					category: categories.join(' / ') || '综合服务',
					shopName: goods.shopName || '',
					mainImage: goods.mainImage ? previewMerchantFile() + goods.mainImage : DEFAULT_GOODS_IMAGE,
					contactName: goods.contactName || '',
					contactPhone: goods.contactPhone || '',
					deliveryText: this.formatDeliveryText(goods),
					deliveryAgreement: goods.deliveryAgreement || '',
					detailContent: goods.goodsDetail || '<p>暂无商品详情</p>'
				}
			},
			formatDeliveryText(goods) {
				const deliveryMap = {
					1: '当日发货',
					2: '24小时内发货',
					3: '48小时内发货',
					4: goods.deliveryCustom || '按约定时间发货'
				}
				return deliveryMap[Number(goods.deliveryType)] || goods.deliveryCustom || ''
			},
			handleConsult() {
				if (!this.goodsInfo.contactPhone) {
					this.$modal.msg('该商品暂未提供咨询电话')
					return
				}
				this.$modal.alert(`联系人：${this.goodsInfo.contactName || '商城服务顾问'}\n咨询电话：${this.goodsInfo.contactPhone}`)
			}
		}
	}
</script>

<style lang="scss" scoped>
	.exhibition-goods-detail {
		min-height: 720px;
		background: #f4f7fb;
	}

	.goods-empty {
		display: flex;
		align-items: center;
		justify-content: center;
		min-height: 620px;
	}
</style>
